"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *  Json Helper
 */
var JsonHelper = /** @class */ (function () {
    function JsonHelper() {
        this.workingValues = [];
    }
    // recursively get objects based on the specifed property key
    JsonHelper.prototype.getValuesFromKey = function (key, json) {
        var obj = typeof json === 'string' ? JSON.parse(json) : json;
        this.workingValues = [];
        this.scanObject(key, obj);
        return this.workingValues;
    };
    JsonHelper.prototype.scanObject = function (key, obj) {
        if (obj) {
            var keys = Object.keys(obj);
            if (keys.indexOf(key) > -1) {
                this.workingValues.push(obj[key]);
            }
            for (var k in obj) {
                if ((typeof obj[k] === 'object' || obj[k] instanceof Array) && obj[k] !== null) {
                    this.scanObject(key, obj[k]);
                }
            }
        }
    };
    return JsonHelper;
}());
exports.JsonHelper = JsonHelper;
//# sourceMappingURL=JsonHelper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/helpers/JsonHelper.js
// module id = 896
// module chunks = 1